import React from 'react';
import MedicalHistoryFormPage from "./MedicalHistoryFormPage"

const MedicalHistoryCreate = () => {
  console.log('MedicalHistoryCreate component loaded');
  
  return (
    <div style={{ width: '100%' }}>
      <MedicalHistoryFormPage />
    </div>
  )
}

export default MedicalHistoryCreate